<h2 mat-dialog-title class="editor-title">
    <span class="editor-title__text">Dynamic Values Editor</span>
    <button
        *ngIf="jsonUrl"
        type="button"
        class="editor-title__link"
        [title]="jsonUrl"
        [matTooltip]="jsonUrl"
        matTooltipPosition="below"
        [attr.aria-label]="justCopied ? 'Copied' : 'Copy Lottie JSON URL'"
        (click)="copyJsonUrl()">
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10 14a4 4 0 0 0 5.66 0l2.83-2.83a4 4 0 1 0-5.66-5.66L11.5 6.85M14 10a4 4 0 0 0-5.66 0L5.5 12.83a4 4 0 1 0 5.66 5.66l1.33-1.33" />
        </svg>
        <span class="editor-title__link-label">{{ justCopied ? 'Copied' : 'Copy link' }}</span>
    </button>
</h2>

<mat-dialog-content>
    <div class="editor-body" [class.editor-body--with-preview]="hasPreview">
        <!--
          One row per change. Each row is a typed EditorRow (TextRow | NumberRow |
          ColorRow | ToggleRow | RgbRow) with the resting + editing state pre-
          computed in TS. Markup of the per-kind controls lives in
          <app-dynamic-value-control>, so any host (this dialog, project-template
          form, etc.) gets the same UX. Editing mutates the dialog's OWN copy —
          nothing reaches the take until Save.
        -->
        <div class="changes-table">
            <div class="table-header row-centered">
                <span class="col-id">Property</span>
                <span class="col-value">Value</span>
            </div>

            <div class="table-row row-centered" *ngFor="let row of rows; trackBy: trackRow">
                <span class="col-id" [matTooltip]="row.tooltip" matTooltipPosition="right">
                    <span class="label-primary">{{ row.label }}</span>
                </span>
                <div class="col-value">
                    <app-dynamic-value-control [row]="row" (valueChange)="onValueChanged()"></app-dynamic-value-control>
                </div>
            </div>

            <div *ngIf="!rows?.length" class="empty-state">No dynamic lottie changes on this take.</div>
        </div>

        <!-- Live preview: re-renders as values change, never mutates the take. -->
        <aside class="preview-pane" *ngIf="hasPreview">
            <span class="preview-pane__label">Preview</span>
            <div class="preview-pane__stage" [style.aspect-ratio]="previewAspectRatio">
                <app-lottie-video-composed
                    *ngIf="toDisplayComposed; else nonComposedPreview"
                    class="preview-player"
                    [compose-configs]="previewComposeConfigs"
                    [displayVgControls]="false"
                    [showLoadingIndication]="true"
                    [special-end-time]="null"
                    [playNowOrWait]="true"
                    [playOrPause]="playOrPause$ | async"
                    [freezeAtFirstFrame]="false"
                    [toMuteVideo]="true">
                </app-lottie-video-composed>
                <ng-template #nonComposedPreview>
                    <dynamic-lottie
                        class="preview-player"
                        [lottieOptions]="{ loop: true }"
                        [config]="previewLottieConfig">
                    </dynamic-lottie>
                </ng-template>
            </div>
        </aside>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
</mat-dialog-actions>
